/**
 * Profile assessment guards + redirects. Adaptive rules live in profileAdaptive.ts.
 */

export {
  isLegacyProfileComplete,
  isAdaptiveProfileComplete,
  isProfileCompleteForAssessment,
  shouldBlockAssessmentAccess,
  PROFILE_GUARD_SELECT,
  type ProfileCompletionRow,
  type ProfileRowForAi,
  type AdaptiveFormInput,
  type UserType,
  emptyAdaptiveForm,
  profileRowToAdaptiveForm,
  validateAdaptiveForm,
  deriveLegacyProfileFields,
  buildAdaptiveContextSnippet,
  buildAdaptiveSupplementForQuestionGen,
  buildAiProfileContextBlock,
  buildReportAdaptiveProfileSupplement,
  buildAdaptiveProfileSummaryForReport,
} from "./profileAdaptive";

import type { ProfileCompletionRow } from "./profileAdaptive";
import { isProfileCompleteForAssessment } from "./profileAdaptive";

/** @deprecated Prefer validateAdaptiveForm with full form state; kept for typing compatibility */
export type ProfileCompletionFields = ProfileCompletionRow;

/** Used by auth + API; same as isProfileCompleteForAssessment */
export function isProfileComplete(
  p: ProfileCompletionRow | null | undefined,
): boolean {
  return isProfileCompleteForAssessment(p);
}

export const ASSESSMENT_PROFILE_BANNER_TITLE =
  "Complete your profile to start your assessment";

export const ASSESSMENT_PROFILE_BANNER_BODY =
  "A short, personalized setup helps us tailor every question and your report to your stage — school, college, work, or a career change.";

export function sanitizeInternalNextPath(
  value: string | null | undefined,
  fallback = "/dashboard",
  profilePath = "/dashboard/profile",
): string {
  if (!value || !value.startsWith("/") || value.startsWith("//")) {
    return fallback;
  }
  if (value.startsWith(profilePath)) {
    return fallback;
  }
  return value;
}

export function profileCompletionRedirectUrl(
  nextPath: string,
  profilePath = "/dashboard/profile",
): string {
  const fallback = profilePath.startsWith("/partner/student/")
    ? "/partner/student/dashboard"
    : "/dashboard";
  const safe = sanitizeInternalNextPath(nextPath, fallback, profilePath);
  return `${profilePath}?next=${encodeURIComponent(safe)}`;
}
